import { Injectable } from '@angular/core';

@Injectable()
export class Rot13Service {
    public rotate(str: string) {
        const rot13Lookup = {
            A: 'N',
            B: 'O',
            C: 'P',
            D: 'Q',
            E: 'R',
            F: 'S',
            G: 'T',
            H: 'U',
            I: 'V',
            J: 'W',
            K: 'X',
            L: 'Y',
            M: 'Z',
            N: 'A',
            O: 'B',
            P: 'C',
            Q: 'D',
            R: 'E',
            S: 'F',
            T: 'G',
            U: 'H',
            V: 'I',
            W: 'J',
            X: 'K',
            Y: 'L',
            Z: 'M',
            a: 'n',
            b: 'o',
            c: 'p',
            d: 'q',
            e: 'r',
            f: 's',
            g: 't',
            h: 'u',
            i: 'v',
            j: 'w',
            k: 'x',
            l: 'y',
            m: 'z',
            n: 'a',
            o: 'b',
            p: 'c',
            q: 'd',
            r: 'e',
            s: 'f',
            t: 'g',
            u: 'h',
            v: 'i',
            w: 'j',
            x: 'k',
            y: 'l',
            z: 'm'
        };

        let output = '';
        str.split('').forEach((inChar) => {
            output += rot13Lookup[inChar] || inChar;
        });

        return output;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src1143190010/src/src/app/shared/services/rot13.service.ts